import { BUDGET_MS } from './manifest';

/*
 * The 200 ms budget for the detector: pure, one step per run. A run can't be interrupted, so going over shows only
 * after the fact. As with the live spore count (utils/spores/liveCount.js), that answer is let go, as it describes a
 * picture already gone, and the next four samples rest. TOO_SLOW_RUN overs in a row mean this device can't, and the
 * detector stops for this camera, leaving sharpness and stillness to do the work.
 */
export const REST_AFTER_OVER = 4;
export const TOO_SLOW_RUN = 3;
const KEEP_TIMES = 200;

export const FRESH_BUDGET = Object.freeze({ overs: 0, rest: 0, tooSlow: false, times: [], kept: 0, skipped: 0 });

/** {state, keep} after a run that took `ms`. */
export function budgetStep(state, ms, budgetMs = BUDGET_MS) {
  const over = ms > budgetMs;
  const overs = over ? state.overs + 1 : 0;
  return {
    state: {
      overs,
      rest: over ? REST_AFTER_OVER : 0,
      tooSlow: state.tooSlow || overs >= TOO_SLOW_RUN,
      times: [...state.times, ms].slice(-KEEP_TIMES),
      kept: state.kept + (over ? 0 : 1),
      skipped: state.skipped + (over ? 1 : 0),
    },
    keep: !over,
  };
}

/** {state, send}: may this sample go, or is it resting? */
export function budgetTick(state) {
  if (state.tooSlow) return { state, send: false };
  if (state.rest > 0) return { state: { ...state, rest: state.rest - 1 }, send: false };
  return { state, send: true };
}

function percentile(sorted, p) {
  return sorted[Math.min(sorted.length - 1, Math.ceil((p / 100) * sorted.length) - 1)];
}

/** What a trial reports: {runs, kept, skipped, p50, p95}, the times in whole milliseconds, null before any run. */
export function budgetSummary(state) {
  const sorted = [...state.times].sort((a, b) => a - b);
  return {
    runs: state.kept + state.skipped,
    kept: state.kept,
    skipped: state.skipped,
    p50: sorted.length ? Math.round(percentile(sorted, 50)) : null,
    p95: sorted.length ? Math.round(percentile(sorted, 95)) : null,
  };
}
